import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';

import { Modal, Button, Spin, Row, Col } from 'antd';

import { Formik, Form, Field } from 'formik';
import type { FormikProps } from 'formik';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IWhiteList } from 'v2/interfaces/whitelist';
import whitelistService, { InitialWhiteList } from 'v2/services/whitelist';

import CreateAndEditSchema from './validations';

const CreateAndEdit = () => {
  const [open] = useObservable(() => whitelistService.getCreateAndEditDialog(), []);
  const [currentWhiteList] = useObservable(() => whitelistService.getCurrentWhiteList(), []);
  const [onSubmit] = useCallbackObservable(
    (values: IWhiteList, { setSubmitting, resetForm }: FormikProps<IWhiteList>) => {
      return whitelistService.saveOrUpdate(values).pipe(
        tap(() => {
          setSubmitting(false);
          resetForm({ values });
          whitelistService.setCreateAndEditDialog(false);
          if (values?.id) return toast.success('WhiteList alterado com sucesso.');
          return toast.success('WhiteList criado com sucesso.');
        }),
        catchError(err => {
          const message = typeof err === 'string' ? err : 'Valide os campos obrigatórios';
          setSubmitting(false);
          toast.error(message);
          return of(true);
        })
      );
    },
    []
  );

  const closeDialog = useCallback(() => {
    whitelistService.setCreateAndEditDialog(false);
  }, []);

  return (
    <Modal open={open} onCancel={closeDialog} footer={null} title={null} destroyOnClose>
      <Formik
        initialValues={currentWhiteList ?? InitialWhiteList}
        enableReinitialize
        validationSchema={CreateAndEditSchema}
        onSubmit={onSubmit}
      >
        {({ values, isValid, isSubmitting }) => (
          <Form id='whitelist-form'>
            <h3 className='mb-4 text-lg font-medium'>{values?.id ? 'Edite o cliente' : 'Adicione um novo cliente'}</h3>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Field
                  id={'customer_name'}
                  name={'customer_name'}
                  component={TextFormField}
                  fullWidth
                  label={'Nome'}
                  placeholder={'Insira o nome'}
                />
              </Col>
              <Col span={24}>
                <Field
                  id={'customer_email'}
                  name={'customer_email'}
                  component={TextFormField}
                  fullWidth
                  label={'E-mail'}
                  placeholder={'Insira o e-mail'}
                />
              </Col>
              <Col span={24}>
                <Field
                  id={'customer_document'}
                  name={'customer_document'}
                  component={TextFormField}
                  fullWidth
                  label={'CPF/CNPJ'}
                  placeholder={'Insira o documento'}
                  mask={'document'}
                />
              </Col>
            </Row>
            <div className='mt-4 flex justify-end gap-2'>
              <Button onClick={closeDialog}>Fechar</Button>
              <Button type='primary' htmlType='submit' disabled={!isValid || isSubmitting}>
                Salvar
                {isSubmitting && <Spin size='small' className='ml-2' />}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateAndEdit;
